import { componentStyle } from '../common/common'
import { hexColorToRGBA } from '@/views/chart/chart/util'
import { formatNumber } from '@/utils/echartsUtils'

import { BASE_ECHARTS_SELECT, DEFAULT_THRESHOLD } from '@/views/chart/chart/chart'
import { getScaleValue } from '@/components/canvas/utils/style'
import { getStrByLang } from '@/utils'

export function baseGaugeOption2(chart_option, chart, scale = 1) {



  // 处理data
  if (chart.data) {

    console.log("chardata------")
    console.log(chart.data)
    let name=getStrByLang(chart.data.series[0].name);
    let dataeaseName=chart.data.fields[0].dataeaseName;


    if (chart.data.series.length > 0) {
      chart_option.series[0].name =name

    /*   if(dataeaseName=="C_e8a9c03cb9d0b43ead5be6ff35049678"){
        const range = []
        //颜色1
        range.push([1,"#E5E9CD"])
        chart_option.series[0].axisLine = {
          lineStyle: {
            color: range
          }
        }
        //颜色2
        chart_option.series[0].itemStyle = {
          color: "#A5B557"
        }
      } */

     /*  chart_option.series[0].axisTick = {
        splitNumber: getScaleValue(5, scale), // 刻度间隔数
        length: getScaleValue(10, scale), // 子刻度线长度
        lineStyle: {
          width: getScaleValue(2, scale) // 子刻度线宽度
        }
      }
      chart_option.series[0].splitLine = {
        length: getScaleValue(18, scale), // 刻度线长度
        lineStyle: {
          width: getScaleValue(2, scale) // 刻度线宽度
        }
      } */
    /*   chart_option.series[0].axisLabel = {
        distance: getScaleValue(20, scale), // 刻度值文字里刻度线距离
        fontSize: getScaleValue(20, scale)// 刻度值字体大小
      } */







      // data只取第一个
      let value=chart.data.series[0].data[0]??0;
      value=formatNumber(value,'###0.00');
      if(value==NaN){
        value="0%";
      }
      const y = {
         name: name,
         value: value
     }

      chart_option.series[0].data.push(y)
    }
  }

  console.log("---------baseGaugeOption------------------------")


  componentStyle(chart_option, chart)
  return chart_option
}
